export const SimStatus = {
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
  TERMINATED: 'Terminated'
}
Object.freeze(SimStatus)

export function getSimStatus(status) {
  switch (status.toLowerCase()) {
    case SimStatus.ACTIVATED.toLowerCase():
      return SimStatus.ACTIVATED
    case SimStatus.DEACTIVATED.toLowerCase():
      return SimStatus.DEACTIVATED
    case SimStatus.SUSPENDED.toLowerCase():
      return SimStatus.SUSPENDED
    default:
      return SimStatus.DEACTIVATED
  }
}

export function getIccid(iccid) {
  return iccid || 'Pending'
}

export function getMsisdn(msisdn) {
  return msisdn || 'Pending'
}

export function getStatus(status) {
  return status
}
